import * as React from "react"
const IconContrast = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 24}
        height={props.height || 24}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            stroke={props.stroke || "#414651"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth || 2}
            d="M12 2c.592 0 1.171.051 1.735.15M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10m0-20v20m5.738-18.191c.954.67 1.786 1.502 2.455 2.456m1.657 4a10.064 10.064 0 0 1 0 3.47m-1.66 4.006c-.67.952-1.5 1.782-2.453 2.45m-4.004 1.66C13.17 21.948 12.59 22 12 22"
        />
    </svg>
)
export default IconContrast
